import {
  Autocomplete,
  Button,
  Cascader,
  Checkbox,
  Dialog,
  Icon,
  Input,
  Loading,
  Message,
  Notification,
  Option,
  Pagination,
  Select,
  Step,
  Steps,
  Table,
  TableColumn,
} from "element-ui";
import locale from "element-ui/lib/locale";
import lang from "element-ui/lib/locale/lang/en";
import Vue from "vue";
import VueContentPlaceholders from "vue-content-placeholders";
import VueInfiniteScroll from "vue-infinite-scroll";
import VueLazyload from "vue-lazyload";
import App from "./App";
import router, { whiteList } from "./router";
import store from "./store";
import { redirectLogin } from "./utils/redirect";
import sensors from "./utils/sensor";

locale.use(lang);

Vue.use(Button);
Vue.use(Pagination);
Vue.use(Checkbox);
Vue.use(Icon);
Vue.use(Autocomplete);
Vue.use(Steps);
Vue.use(Step);
Vue.use(Table);
Vue.use(TableColumn);
Vue.use(Input);
Vue.use(Dialog);
Vue.use(Select);
Vue.use(Option);
Vue.use(Cascader);
Vue.use(VueContentPlaceholders);
Vue.use(Loading.directive);
Vue.use(VueInfiniteScroll);
Vue.use(VueLazyload, {
  loading: "/static/imgs/logo.png",
});

Vue.prototype.$loading = Loading.service;
Vue.prototype.$notify = Notification;
Vue.prototype.$message = Message;
Vue.prototype.$sensors = sensors;

Vue.config.productionTip = false;

router.beforeEach(function (to, from, next) {
  const login = store.state.login;
  const toPath = to.path;
  if (login || whiteList.indexOf(toPath) !== -1) {
    next();
  } else {
    redirectLogin();
  }
});

/* eslint-disable no-new */
new Vue({
  el: "#app",
  store,
  router,
  render: (h) => h(App),
});



// WEBPACK FOOTER //
// ./src/main.js